/* eslint-disable @typescript-eslint/no-explicit-any */
import { PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Spinner from "common/components/Spinner"
import { MODAL_STYLES } from "constants/primereactStyles"
import { getValidateModalStatusSelector } from "features/User/redux/selectors/userSelectors"
// eslint-disable-next-line import/no-cycle
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"

export const ModalValidacion = () => {
  const { t } = useTranslation()
  const { showValidarEmpresaLoadingModal: isModalOpen } = useSelector(
    getValidateModalStatusSelector
  )

  return (
    <PrimeReactModal
      visible={isModalOpen}
      className='tw-w-128 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div
          key='divider'
          className='tw-px-4 tw-pb-4'
        />
      }
    >
      <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center  tw-bg-simple-20 tw-mx-auto tw-mt-5 tw-mb-4'>
        <div className='tw-rounded-full tw-w-16 tw-h-16 tw-flex tw-justify-center tw-items-center tw-border tw-border-simple-90 tw-border-opacity-5 tw-bg-white tw-mx-auto'>
          <FontAwesomeIcon
            icon={["fal", "file-certificate"]}
            className='tw-w-8 tw-h-8 tw-text-primary'
          />
        </div>
      </div>
      <div className='tw-text-2xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
        {t("perfilEmpresa.company.modalValidating")}
      </div>
      <div className='tw-w-full tw-flex tw-flex-col tw-text-base tw-px-4'>
        <Spinner />
      </div>
    </PrimeReactModal>
  )
}
